import { render, staticRenderFns } from "./ProfileField.vue?vue&type=template&id=38274143&scoped=true"
import script from "./ProfileField.vue?vue&type=script&lang=js"
export * from "./ProfileField.vue?vue&type=script&lang=js"
import style0 from "./ProfileField.vue?vue&type=style&index=0&id=38274143&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38274143",
  null
  
)

export default component.exports